import { render, staticRenderFns } from "./AdxList.vue?vue&type=template&id=18e450f4"
import script from "./AdxList.vue?vue&type=script&lang=js"
export * from "./AdxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports